import "react-toastify/dist/ReactToastify.css";
import "styles/app.scss";

import { Box } from "@mui/material";
import ScreenLoader from "components/ScreenLoader";
import { authActions } from "modules/auth";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useAppDispatch, useAppSelector } from "redux/hooks";

import IndexPage from "./IndexPage";
import LoginPage from "./LoginPage";
import PageUnauthorized from "./PageUnauthorized";

const App = () => {
  const { authUser, isLoggingOut } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { pathname } = location;
  const successCallback = () => {
    console.log("Login Successful");
    setLoading(false);
  };

  useEffect(() => {
    dispatch(authActions.setLoggingOutFlag(false));
    let splits = pathname.split("/").filter((data) => !!data);
    // #region for testing: cookie expiring in 1 min/end of 2023
    // var date = new Date();
    // date.setTime(date.getTime() + 60 * 1000);
    // document.cookie = `id=77c9bd02-41f9-4c33-a457-b5834ac3ae1b; expires=${date.toUTCString()}`;
    // document.cookie =
    //   "id=77c9bd02-41f9-4c33-a457-b5834ac3ae1b; expires=Thu, 18 Dec 2023 12:00:00 UTC";
    // #endregion for testing: cookie expiring in 1 min

    if (
      !authUser &&
      (splits.length === 0 ||
        (splits.length >= 1 &&
          splits[0].toLowerCase() !== "login" &&
          splits[0].toLowerCase() !== "unauthorized"))
    ) {
      try {
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";").map((m) => m.trim());

        let token = ca.find((f) => f.indexOf("MStation=id=") !== -1).substring(12);
        if (!!token) {
          dispatch(authActions.loginWithCookie({ successCallback, token }));
        }
      } catch (_e) {
        //redirect to unauthorized page
        setLoading(false);
        window.location.href = "/unauthorized";
      }
    } else {
      setLoading(false);
    }
  }, []);

  if (isLoggingOut || loading)
    return (
      <Box display="flex" flex={1} height="100vh" justifyContent="center" alignItems="center">
        <ScreenLoader isScreenLoader />
      </Box>
    );

  return (
    <>
      <Routes>
        <Route path="*" element={authUser ? <IndexPage /> : <PageUnauthorized />} />
        <Route path="login/*" element={<LoginPage />} />
        <Route path="unauthorized" element={<PageUnauthorized />} />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default App;
